import store from '@/stores'
// Views
import PortsHome from '@/views/ports/Home'
import MeasurementsIndex from '@/views/measurements/Index'
import Alerts from '@/views/alerts/Index'
import CostSplitting from '@/views/cost_splitting/Index'
import Configuration from '@/views/configuration/Index'
import BindingCode from '@/views/BindingCode'
// import PortsSettings from '@/views/dashboard/Settings'
import Group from '@/views/group/Index'
import Profile from '@/views/profile/Index'
import EvSensAdmin from '@/views/evsens_admin/Index'
import Sharing from '@/views/sharing/Index'
import Help from '@/views/help/Index'

let checkDevicesLength = () => {
  return new Promise((resolve, reject) => {
    store.dispatch('devicesStore/devices')
    .then( (response) => {
      if (response.data.length == 0) {
        reject({message: 'no devices'})
      } else {
        resolve()
      }
    })
    .catch( (e) => {
      reject(e)
    })
  })
}


export default [{
  path: '',
  name: 'ports',
  component: PortsHome,
  meta: { auth: true },

  /*
  beforeEnter: (to, from, next) => {
    checkDevicesLength()
    .then(() => {
      store.dispatch('chargesStore/summarize').then(next).catch((error) => {
        next(error)
      })
    })
    .catch((e) => {
      console.log(e);
      next({name: "bindingcode"})
    })
  }
  */
},


{
  path: 'mesures-electriques',
  component: MeasurementsIndex,
  name: 'measurements',
  meta: { auth: true },
  /*
  beforeEnter: (to, from, next) => {
    checkDevicesLength().then(next).catch(()=> {
      next({name: "bindingcode"})
    })
  }
  */

},


{
  path: 'code-jumelage',
  component: BindingCode,
  name: 'bindingcode',
  meta: { auth: true }
},

{
  path: 'configuration',
  component: Configuration,
  name: 'configuration',
  meta: { auth: true },

  /*
  beforeEnter: (to, from, next) => {
    let getCarsData = [store.dispatch('carsStore/getCars')]
    checkDevicesLength().then( () => {
      store.dispatch('carsStore/getCars').then(next)
      .catch((error) => {
        next(error)
      })
    }).catch(() => {
      next({name: "bindingcode" })
    })

  }
  */


},

{
  path: 'cost-splitting',
  component: CostSplitting,
  name: 'cost-splitting',
  meta: { auth: true },
},


{
  path: 'group',
  component: Group,
  name: 'group',
  meta: { auth: true },
},

{
  path: 'profile',
  component: Profile,
  name: 'profile',
  meta: { auth: true },
},

{
  path: 'evsensadmin',
  component: EvSensAdmin,
  name: 'evsensadmin',
  meta: { auth: true },
},

{
  path: 'alerts',
  component: Alerts,
  name: 'alerts',
  meta: { auth: true },
},

{
  path: 'sharing',
  component: Sharing,
  name: 'sharing',
  meta: { auth: true },
},

{
  path: 'help',
  component: Help,
  name: 'help',
  meta: { auth: true },
},


]



// WEBPACK FOOTER //
// ./src/router/dashboard.js